var _defs, _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgFacilityRoleIcon(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: "inherit",
    height: "inherit",
    viewBox: "0 0 800 800",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_4",
    "data-name": "Rectangle 4",
    width: 433.184,
    height: 344.158
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-Facility"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 800,
    height: 800
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Facility",
    clipPath: "url(#clip-Facility)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_34",
    "data-name": "Group 34",
    transform: "translate(182.988 227.933)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_33",
    "data-name": "Group 33",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_10758",
    "data-name": "Path 10758",
    d: "M427.278,299.53H408.795V108.049a5.967,5.967,0,0,0-3.62-5.434l-120.7-52.4V5.905A5.925,5.925,0,0,0,278.567,0H30.422a5.924,5.924,0,0,0-5.9,5.907V299.53H5.906A5.924,5.924,0,0,0,0,305.437v32.815a5.923,5.923,0,0,0,5.907,5.906H427.278a5.923,5.923,0,0,0,5.905-5.907V305.435a5.923,5.923,0,0,0-5.905-5.905m-222.473,0H160.4V194.454h44.4Zm-56.217,0h-44.4V194.454h44.4Zm76.028-117.014H84.375v-6.76H224.617Zm-8,11.938h18.47l-1.587-.793a6.066,6.066,0,0,0,3.052-5.113v-18.7a5.923,5.923,0,0,0-5.907-5.905H78.466a5.923,5.923,0,0,0-5.905,5.907v18.7a5.923,5.923,0,0,0,5.907,5.905H92.374V299.53H36.332V11.938H272.661V299.53H216.618ZM284.475,299.53V63.321l112.257,48.667V299.53ZM11.814,311.468H421.249v20.876H11.814Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_10759",
    "data-name": "Path 10759",
    d: "M250.43,66.515H126.357a5.924,5.924,0,0,0-5.906,5.907v72.934a5.923,5.923,0,0,0,5.906,5.905H250.508a5.943,5.943,0,0,0,5.829-6.03V72.42a5.924,5.924,0,0,0-5.907-5.905M244.4,139.324H194.3V114.858h50.1Zm0-36.279H194.3V78.329h50.1Zm-61.911,36.279H132.265V114.858h50.222Zm0-36.279H132.265V78.329h50.222Z",
    transform: "translate(-33.898 -18.719)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_10760",
    "data-name": "Path 10760",
    d: "M488.786,162.842H432.568a5.923,5.923,0,0,0-5.905,5.907V309.167a5.922,5.922,0,0,0,5.905,5.905h56.378a5.834,5.834,0,0,0,5.746-5.907V168.747a5.923,5.923,0,0,0-5.907-5.905m-50.309,11.814h44.278v21H438.477Zm0,32.814h44.278v25.581H438.477Zm0,37.394h44.278v25.7H438.477Zm0,37.519h44.278v20.875H438.477Z",
    transform: "translate(-120.075 -45.828)"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Ellipse_1",
    "data-name": "Ellipse 1",
    transform: "translate(1 1)",
    fill: "none",
    stroke: "#000",
    strokeWidth: 17
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 399.5,
    cy: 399.5,
    r: 399.5,
    stroke: "none"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 399.5,
    cy: 399.5,
    r: 391,
    fill: "none"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgFacilityRoleIcon);
export default __webpack_public_path__ + "static/media/FacilityRoleIcon.d831b06c4e5891ade5630fedda98ade6.svg";
export { ForwardRef as ReactComponent };